<template>
  <div id="supportTicketAddNew" class="xbig ybig">
    <vs-prompt
      name="supportTicket"
      :vs-title="supportTicketIdProp != null ? 'Destek Kaydı Güncelle ' + ' # ' + supportTicketIdProp + ' ( ' + supportItem.status + ' ) ' : 'Yeni Destek Kaydı'"
      vs-accept-text="Kaydet"
      vs-cancel-text="Vazgeç"
      vs-button-cancel="border"
      @vs-cancel="$emit('supportTicketPopupClosed', supportItem)"
      @vs-accept="SaveTicket()"
      @vs-close="$emit('supportTicketPopupClosed', supportItem)"
      :vs-active.sync="supportTicketPopup"
      :vs-buttons-hidden="supportItem != null && supportItem.closeDate != null"
    >
      <template v-if="supportItem.customerId == null">
        <div class="vx-row mb-3" style=" flex-wrap: nowrap;">
          <div class="vx-col md:w-1/4 ml-5">
            <vs-button color="success" @click="addNewCustomer">Müşteri Ekle</vs-button>
          </div>
          <div class="vx-col md:w-2/4 w-full">
            <vs-input icon-pack="feather" icon="icon-user" class="w-full" placeholder="Müşteri Ara" v-model="customerSearchQuery" @keyup="delayedSearch()" />
          </div>
          <div class="vx-col md:w-1/4 w-full" style="text-align: center;">
            <vs-button type="border" class="ml-5" @click="delayedSearch()">Ara</vs-button>
          </div>
        </div>

        <div class="vx-row mt-2 w-full">
          <div class="vx-col w-full">
            <vs-table search :maxItems="3" :pagination="true" :data="customerSearchQueryResult">
              <template slot="thead">
                <vs-th class="w-1/3">Müşteri</vs-th>
                <vs-th class="w-1/6">Seç</vs-th>
              </template>
              <template slot-scope="{ data }">
                <vs-tr :key="tr.customerId" v-for="(tr, i) in data" class="pt-0 pb-1">
                  <vs-td class="pt-0 pb-1" style="white-space: nowrap;">
                    <b> {{ i + 1 + " . " }}</b> {{ tr.firstName.substr(0, 30) }}
                  </vs-td>

                  <td class="flex">
                    <input
                      type="radio"
                      class="vs-radio"
                      v-model="supportItem.customerId"
                      :value="tr.customerId"
                      @change="
                        supportItem.customerName = tr.firstName;
                        supportItem.phone = tr.phone;
                        getProductList();
                      "
                    />
                    <a :href="'/contactsView/' + tr.customerId" style="margin-left:15px;margin-top:5px" target="_blank">Müşteri</a>
                  </td>
                </vs-tr>
              </template>
            </vs-table>
          </div>
        </div>
      </template>

      <template v-if="supportItem.customerId > 0">
        <div class="vx-row mt-5">
          <h1 style="font-size: 20px; text-align: center; font-weight: 600; margin: 20px auto; ">
            MÜŞTERİ
          </h1>
        </div>
        <div class="vx-row mb-5">
          <div class="vx-col">
            <b> {{ supportItem.customerName + " ( Customer Id : " + supportItem.customerId + " Telefon : " + supportItem.phone + " ) " }}</b>
          </div>
          <div class="vx-col">
            <a :href="'/contactsView/' + supportItem.customerId" target="_blank">Müşteri</a>
          </div>
          <div class="vx-col" v-if="supportItem.supportId == null">
            <feather-icon icon="TrashIcon" title="Yenile" style="margin-top:-9px" @click="supportItem.customerId = null" />
          </div>
        </div>
      </template>

      <div class="vx-row">
        <div class="vx-col w-1/4 mt-5">
          <label class="text-sm"><b>Oluşturan</b></label>
          <v-select disabled v-model="supportItem.userId" placeholder="Destek Oluşturan" :options="userList" label="userName" class="w-full" :reduce="(row) => row.userId">
            <span slot="no-options">Eşleşen Veri Yok</span>
          </v-select>
        </div>
        <div class="vx-col w-1/4 mt-5">
          <label class="text-sm"><b>Atanan</b></label>
          <v-select v-model="supportItem.assignUserId" placeholder="Atanan" :options="userList" label="userName" class="w-full" :reduce="(row) => row.userId">
            <span slot="no-options">Eşleşen Veri Yok</span>
          </v-select>
        </div>
        <div class="vx-col w-1/4 mt-5">
          <label class="text-sm"><b>Durumu</b></label>
          <v-select class="w-full mb-0" placeholder="Destek Kayıt Statüsü" :options="supportStatusList" v-model="supportItem.status" label="name" :reduce="(row) => row.value">
            <span slot="no-options">Eşleşen Veri Yok</span>
          </v-select>
        </div>
        <div class="vx-col w-1/4 mt-5">
          <label class="text-sm"><b>Destek Türü</b></label>
          <v-select class="w-full mb-0" placeholder="Destek Türü" :options="supportTypeList" v-model="supportItem.type" label="name" :reduce="(row) => row.value">
            <span slot="no-options">Eşleşen Veri Yok</span>
          </v-select>
        </div>
      </div>

      <div class="vx-row">
        <div class="vx-col w-1/4 mt-5">
          <label class="text-sm"><b>Öncelik Derecesi</b></label>
          <v-select v-model="supportItem.priority" placeholder="Öncelik" :options="priorityList" label="name" class="w-full" :reduce="(row) => row.value">
            <span slot="no-options">Eşleşen Veri Yok</span>
          </v-select>
        </div>
      </div>

      <div class="vx-row">
        <div class="vx-col w-2/12 mt-5">
          <label class="text-sm"><b>Açılış Tarihi</b></label>
          <vs-input readonly="true" type="text" style="width:165px ; " v-model="supportItem.assignDate" />
        </div>
        <div class="vx-col w-2/12 mt-5">
          <label class="text-sm"><b>Kapanış Tarihi</b></label>
          <vs-input readonly="true" type="text" style="width:165px ; " v-model="supportItem.closeDate" />
        </div>

        <div class="vx-col w-2/12 mt-5">
          <label class="text-sm"><b>Aldığı Ürün</b></label>
          <v-select class="w-full mb-0" placeholder="Ürün Seçiniz" :options="productList" v-model="supportItem.productId" label="product" :reduce="(row) => row.productId">
            <span slot="no-options">Eşleşen Veri Yok</span>
          </v-select>
        </div>
        <div class="vx-col mt-10">
          <feather-icon icon="SearchIcon" class="stoke-current cursor-pointer" @click.stop="productSearchPopupParent = true" />
        </div>

        <div class="vx-col md:w-4/12 w-full ml-2 mt-10" v-if="supportItem.productId">
          <span style="margin-top:5px"> {{ supportItem.productName + " ( ProductId = " + supportItem.productId + " )" }}</span>
        </div>
        <product-search v-if="productSearchPopupParent" :productSearchPopupProp="productSearchPopupParent" @ProductSearchPopupClosedChildEmit="ProductSearchPopupClosedParent($event)"></product-search>
      </div>

      <div class="vx-row">
        <div class="vx-col w-8/12 mt-5">
          <label class="text-sm"><b>Açıklama Ekleyiniz</b></label>
          <vs-textarea rows="2" cols="60" v-model="supportItem.description" name="txtDescription" />
        </div>
        <div class="vx-col w-3/12 mt-12">
          <label class="text-sm "><b>Geçen Süre</b></label>

          <span style="margin-top:25px"> {{ supportItem.day + " Gün " + supportItem.hour + " Saat " + supportItem.minute + " Dakika " + supportItem.second + " Saniye" }}</span>
        </div>
      </div>

      <div class="vx-row mt-5">
        <div class="vx-col w-full">
          <label><b>Tarihçe</b></label>
        </div>
        <div class="vx-col w-full mt-2" style="" v-html="supportItem.supportTicketLogHtml"></div>
      </div>
    </vs-prompt>
    <add-new-customer :addnew="addNewCust" v-if="addNewCust" :withAdditionalData="false" @hideAddNewRegister="hideAddNewCust"></add-new-customer>
  </div>
</template>

<script>
import vSelect from "vue-select";
import { repository } from "@/_services/repository.js";
import addNewCustomer from "../contacts/addNewPrompt.vue";
import ProductSearch from "../Search/ProductSearch.vue";

export default {
  components: {
    vSelect,
    addNewCustomer,
    ProductSearch,
  },
  props: {
    supportTicketPopupProp: null,
    supportTicketIdProp: null,
    customerIdProp: null,
  },
  data() {
    return {
      productSearchPopupParent: false,
      userList: [],
      supportItem: { customerName: null, customerId: null, assingUserId: null, status: "Opened", userId: this.$store.state.userData.userId, type: null, operation: "InsertTicket", phone: null },
      supportTypeList: [
        { name: "Yardım", value: "Help" },
        { name: "Kurulum", value: "Setup" },
        { name: "Güncelleme", value: "Update" },
        { name: "Aktivasyon", value: "Activation" },
        { name: "Hata", value: "Error" },
        { name: "Görev Yönetimi", value: "OrderManagement" },
        { name: "Satış", value: "Sale" },
      ],
      priorityList: [
        { name: "Acil", value: "Urgent" },
        { name: "Yüksek", value: "High" },
        { name: "Normal", value: "Normal" },
        { name: "Düşük", value: "Low" },
      ],
      supportStatusList: [
        { name: "Yeni Kayıt", value: "Opened" },
        { name: "Beklemede", value: "Waiting" },
        { name: "Meşgul - Ulaşılamadı", value: "Busy" },
        { name: "Üreticiye Gönderildi", value: "SentToSupplier" },
        { name: "Onarımda", value: "Repairing" },
        { name: "Ödeme Bekleniyor", value: "AwaitingPayment" },
        { name: "Çözüldü", value: "Solved" },
      ],
      customerSearchQuery: null,
      customerSearchQueryResult: [],
      currenttype: "",

      customerSearch: [],
      searchQuery: "",
      addNewCust: null,
      selectedCustomer: {},
      productSelection: [],
      imageList: [],

      orderCreatingProperties: {},

      activeDeviceFeatures: false,
      productList: [{ productId: null, productName: null }],
    };
  },
  computed: {
    supportTicketPopup: {
      get() {
        if (this.supportTicketPopupProp && (this.supportTicketIdProp != null || this.customerIdProp != null)) this.GetSupportTicket();

        return this.supportTicketPopupProp;
      },
      set() {},
    },
  },
  watch: {},
  methods: {
    ProductSearchPopupClosedParent: async function(v) {
      this.productSearchPopupParent = false;
      if (v) {
        this.supportItem.productId = v.productId;
        this.supportItem.productName = v.productName;
      } else {
        this.supportItem.productId = null;
        this.supportItem.productName = null;
      }
      console.log("product child is closed", v);
    },

    getProductList: async function() {
      this.productList = await repository.getById("Customer/getProductList", this.supportItem.customerId).then((r) => r.list);
    },

    getUsers: async function() {
      this.userList = await repository.postEntity("HumanResource/getUser", { status: 1 }).then((r) =>r.list);
      this.userList=this.userList.filter(f=>f.userId!=123);
    },
    //müşteriler sayfasından ekleme paneli
    addNewCustomer() {
      this.addNewCust = true;
    },
    hideAddNewCust() {
      this.addNewCust = false;
    },

    delayedSearch: async function() {
      if (this.delayedSearchTimer) {
        clearTimeout(this.delayedSearchTimer);
        this.delayedSearchTimer = null;
      }
      this.delayedSearchTimer = setTimeout(async () => {
        if (this.customerSearchQuery && this.customerSearchQuery.length > 2) {
          await this.CustomerSearch();
        }
      }, 500);
    },

    CustomerSearch: async function() {
      this.customerSearchQueryResult = await repository.getWithParam("Customer/search", "searchQuery=" + this.customerSearchQuery + "&pageSize=100").then((r) => r.list);

      console.log(this.customerSearchQueryResult);
    },

    cancel() {},

    SaveTicket: async function(messageText) {
      let resultConfirm2 = await this.$swal.fire({
        icon: "warning",
        title: "Devam etmek istediğinize emin misiniz?",
        text: messageText,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Evet",
        cancelButtonText: "Hayır",
      });

      if (resultConfirm2.isConfirmed) null;
      else return;
      this.$vs.loading();
      await repository.postEntity("Support/SaveSupportTicket", this.supportItem);
      this.$vs.loading.close();

      await this.$swal.fire({
        icon: "success",
        title: "İşlem Başarılı",
        //text: "",
        showCancelButton: false,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Tamam",
        cancelButtonText: "Hayır",
      });
      this.$emit("supportTicketPopupClosed", this.supportItem);
    },

    GetSupportTicket: async function() {
      if (this.supportTicketIdProp > 0) {
        this.supportItem = await repository.postEntity("Support/GetSupportTicket", { supportTicketId: this.supportTicketIdProp }).then((r) => r.list[0]);
        this.supportItem.operation = "UpdateTicket";
      }

      if (this.customerIdProp != null) {
        this.customerSearchQuery = "CustomerId=" + this.customerIdProp;
        await this.CustomerSearch();
        this.supportItem.customerId = this.customerIdProp;
        this.supportItem.customerName = this.customerSearchQueryResult[0].firstName;
        this.supportItem.phone = this.customerSearchQueryResult[0].phone;
        await this.getProductList();
      }

      console.log(this.supportItem);
    },
  },
  mounted() {
    document.addEventListener("keydown", (e) => {
      if (e.keyCode == 27) {
        if (!this.productSearchPopupParent)
        this.$emit("supportTicketPopupClosed", this.supportItem);
      }
    });
  },
  created() {
   this.getUsers();
  },
};
</script>

<style lang="scss" scoped></style>
